var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
    },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { lg: "6" } }, [
                _c("h3", { staticClass: "mb-1" }, [
                  _vm._v(
                    _vm._s(_vm.$t(_vm.getTypeForDisplay())) +
                      " " +
                      _vm._s(_vm.invoice.invoiceNumber)
                  ),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [_vm._v("Customer Reference Number:")]),
                  _vm._v(
                    " " + _vm._s(_vm.invoice.customerReferenceNumber) + " "
                  ),
                  _vm.isInvoiceEditable()
                    ? _c("i", {
                        staticClass: "el-icon-edit",
                        on: {
                          click: function ($event) {
                            return _vm.editSingleField(
                              "customerReferenceNumber",
                              "Customer Reference Number"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.invoice.udf1Name ? _vm.invoice.udf1Name : "UDF"
                      ) + " "
                    ),
                    _vm.isInvoiceEditable()
                      ? _c("i", {
                          staticClass: "el-icon-edit",
                          on: {
                            click: function ($event) {
                              return _vm.editSingleField("udf1Name", "UDF Name")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(":"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.invoice.udf1) + " "),
                  _vm.isInvoiceEditable()
                    ? _c("i", {
                        staticClass: "el-icon-edit",
                        on: {
                          click: function ($event) {
                            return _vm.editSingleField("udf1", "UDF")
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [_vm._v("Remark:")]),
                  _vm._v(" " + _vm._s(_vm.invoice.remark)),
                  _vm.isInvoiceEditable()
                    ? _c("i", {
                        staticClass: "el-icon-edit",
                        on: {
                          click: function ($event) {
                            return _vm.editSingleField("remark", "Remark")
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [_vm._v("Account Code:")]),
                  _vm._v(" " + _vm._s(_vm.invoice.accountCode)),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [_vm._v("Currency Profile:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.currencyProfile.id
                          ? _vm.currencyProfile.name
                          : _vm.invoice.currencyProfileId
                      )
                  ),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [_vm._v("Currency Profile Rate:")]),
                  _vm._v(" "),
                  !_vm.invoice.currencyProfileBillingPeriod
                    ? _c("span", [_vm._v("Latest Effective Rate")])
                    : _c("span", [
                        _vm._v(
                          "Specific Billing Period: " +
                            _vm._s(_vm.invoice.currencyProfileBillingPeriod)
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInvoiceEditable()
                    ? _c("i", {
                        staticClass: "el-icon-edit",
                        on: {
                          click: function ($event) {
                            return _vm.editProfileRate()
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "invoice-row" }, [
                  _c("strong", [_vm._v("Total Due:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.invoice.totalAmount) +
                      " " +
                      _vm._s(_vm.invoice.totalAmountCurrency)
                  ),
                ]),
              ]),
              _c(
                "b-col",
                { attrs: { lg: "6" } },
                [
                  _vm.action === "view" &&
                  _vm.getErpCan(_vm.getPermissionPrefix() + ".Edit")
                    ? _c(
                        "el-button",
                        {
                          staticClass: "mr-1 float-right",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.goEdit()
                            },
                          },
                        },
                        [_vm._v("Edit")]
                      )
                    : _vm._e(),
                  _vm.action === "edit"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "mr-1 float-right",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.goView()
                            },
                          },
                        },
                        [_vm._v("View Only")]
                      )
                    : _vm._e(),
                  _vm.invoice.accruals && _vm.isAccrualEnabled()
                    ? _c(
                        "el-button",
                        {
                          staticClass: "mr-1 float-right",
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.showAccruals()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "Accruals (" +
                              _vm._s(_vm.invoice.accruals.length) +
                              ")"
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.isInvoiceEditable()
                    ? _c(
                        "el-button",
                        {
                          staticClass: "mr-1 float-right",
                          attrs: { type: "info" },
                          on: {
                            click: function ($event) {
                              _vm.isShowEditFootnote = true
                            },
                          },
                        },
                        [_vm._v("Edit Footnote")]
                      )
                    : _vm._e(),
                  _c("h3", { staticClass: "mb-1" }, [_vm._v(" ")]),
                  _c(
                    "p",
                    { staticClass: "invoice-row" },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.getTypeForDisplay()) + " Status:"),
                      ]),
                      _vm._v(" "),
                      _c("InvoiceStatusTag", { attrs: { item: _vm.invoice } }),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [_vm._v("Billing Period:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.invoice.billingPeriodStart) +
                        " - " +
                        _vm._s(_vm.invoice.billingPeriodEnd) +
                        " (" +
                        _vm._s(_vm.invoice.billingPeriod) +
                        " "
                    ),
                    _vm.isInvoiceEditable()
                      ? _c("i", {
                          staticClass: "el-icon-edit",
                          on: {
                            click: function ($event) {
                              _vm.editSingleField(
                                "billingPeriod",
                                "Billing Period (Sun)"
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(")"),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.getTypeForDisplay()) + " Time:"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatWithCurrentTimezone(_vm.invoice.invoiceTime)
                        )
                    ),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [_vm._v("Confirm Time:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatWithCurrentTimezone(_vm.invoice.confirmTime)
                        )
                    ),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [_vm._v("F&A Confirm Time:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatWithCurrentTimezone(
                            _vm.invoice.confirmFaTime
                          )
                        )
                    ),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [_vm._v("Sun Close Time:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatWithCurrentTimezone(
                            _vm.invoice.sunCloseTime
                          )
                        )
                    ),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [_vm._v("Sent Time:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatWithCurrentTimezone(_vm.invoice.sentTime)
                        )
                    ),
                  ]),
                  _vm.invoice.type !== "CREDIT_NOTE"
                    ? _c("p", { staticClass: "invoice-row" }, [
                        _c("strong", [_vm._v("Due Date:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatWithCurrentTimezone(_vm.invoice.dueTime)
                            )
                        ),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "invoice-row" }, [
                    _c("strong", [_vm._v("Payment Terms:")]),
                    _vm._v(" " + _vm._s(_vm.invoice.paymentTermDays) + " Days"),
                  ]),
                  _vm.isAccrualEnabled()
                    ? _c("p", { staticClass: "invoice-row" }, [
                        _c("strong", [_vm._v("Accrual Billing Period:")]),
                        _vm._v(" " + _vm._s(_vm.invoice.accrualBillingPeriod)),
                      ])
                    : _vm._e(),
                  _vm.isAccrualEnabled()
                    ? _c("p", { staticClass: "invoice-row" }, [
                        _c("strong", [_vm._v("Accrual Amount Period:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.invoice.accrualTotalAmount) +
                            " " +
                            _vm._s(_vm.invoice.accrualTotalAmountCurrency)
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("hr"),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "6" } },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.invoice.type === "CREDIT_NOTE"
                          ? _vm.$t("To")
                          : _vm.$t("Invoice To")
                      )
                    ),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _vm._v(_vm._s(_vm.organization.companyName)),
                  ]),
                  _c("p", { staticClass: "invoice-row" }, [
                    _vm._v(_vm._s(_vm.organization.companyAddress)),
                  ]),
                  _vm._l(
                    _vm.organization.companyContacts,
                    function (companyContact) {
                      return _c("div", { staticClass: "mt-2" }, [
                        _c("p", { staticClass: "invoice-row" }, [
                          _vm._v(_vm._s(companyContact.name)),
                        ]),
                        _c("p", { staticClass: "invoice-row" }, [
                          _vm._v(_vm._s(companyContact.phone)),
                        ]),
                        _c("p", { staticClass: "invoice-row" }, [
                          _vm._v(_vm._s(companyContact.email)),
                        ]),
                      ])
                    }
                  ),
                ],
                2
              ),
              _c(
                "b-col",
                { attrs: { lg: "6" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("Bill To")))]),
                  _vm._l(_vm.organization.faContacts, function (faContact) {
                    return _c("div", { staticClass: "mt-2" }, [
                      _c("p", { staticClass: "invoice-row" }, [
                        _vm._v(_vm._s(faContact.name)),
                      ]),
                      _c("p", { staticClass: "invoice-row" }, [
                        _vm._v(_vm._s(faContact.phone)),
                      ]),
                      _c("p", { staticClass: "invoice-row" }, [
                        _vm._v(_vm._s(faContact.email)),
                      ]),
                    ])
                  }),
                  _c("p", { staticClass: "invoice-row" }, [_vm._v(" ")]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("hr"),
      _c("h5", [_vm._v("Charges")]),
      _vm.invoice.type !== "CREDIT_NOTE"
        ? _c("div", { staticClass: "mb-1" }, [
            _c(
              "span",
              {
                staticClass: "mr-1 text-center",
                style: _vm.getInvoiceIconStyle("CBO", _vm.invoice),
              },
              [_vm._v("CBO ⬤")]
            ),
            _c(
              "span",
              {
                staticClass: "mr-1 text-center",
                style: _vm.getInvoiceIconStyle("Fulfillment", _vm.invoice),
              },
              [_vm._v("Fulfillment ⬤")]
            ),
            _c(
              "span",
              {
                staticClass: "mr-1 text-center",
                style: _vm.getInvoiceIconStyle("Others", _vm.invoice),
              },
              [_vm._v("Other ⬤")]
            ),
          ])
        : _vm._e(),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.invoice.items,
            "row-class-name": _vm.tableRowClassName,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "chargeCode", label: "Code", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "Charge Code not included in any Accruals",
                          placement: "top-start",
                        },
                      },
                      [
                        !_vm.isChargeCodeValid(
                          scope.row.warehouseCode,
                          _vm.invoice
                        )
                          ? _c("i", { staticClass: "el-icon-warning warning" })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" " + _vm._s(scope.row.chargeCode) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "warehouseCode", label: "W/H Code", width: "100" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "originalAmount",
              label: "Unit Price",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.unitPrice) +
                        " " +
                        _vm._s(scope.row.originalCurrency)
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "qty", label: "Qty", width: "60" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "originalAmount",
              label: "Original Amount",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.originalAmount) +
                        " " +
                        _vm._s(scope.row.originalCurrency)
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "amount", label: "Converted Amount", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            scope.row.originalCurrency === scope.row.currency
                              ? "-"
                              : scope.row.originalCurrency +
                                "/" +
                                scope.row.currency +
                                ": " +
                                scope.row.exchangeRate,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.amount) +
                              " " +
                              _vm._s(scope.row.currency)
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "amount", label: "Accrual Amount", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.accrualAmount !== null
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                scope.row.currency ===
                                scope.row.accrualAmountCurrency
                                  ? "-"
                                  : scope.row.currency +
                                    "/" +
                                    scope.row.accrualAmountCurrency +
                                    ": " +
                                    scope.row.accrualExchangeRate,
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.accrualAmount) +
                                  " " +
                                  _vm._s(scope.row.accrualAmountCurrency)
                              ),
                            ]),
                          ]
                        )
                      : _c("div", [_vm._v("Unconfirmed")]),
                    _c(
                      "div",
                      [
                        _vm._l(_vm.invoice.accruals, function (accrual) {
                          return accrual.warehouseCode ===
                            scope.row.warehouseCode
                            ? _c("div", { staticClass: "text-muted" }, [
                                _c("span", {
                                  staticClass: "el-icon-price-tag orange",
                                }),
                                _vm._v(
                                  "Inv: " + _vm._s(accrual.accrualNumber) + " "
                                ),
                              ])
                            : _vm._e()
                        }),
                        scope.row.accrualId !== null
                          ? _c("div", { staticClass: "text-muted" }, [
                              _c("span", {
                                staticClass: "el-icon-price-tag orange",
                              }),
                              _vm._v(
                                "Item: " +
                                  _vm._s(scope.row.accrual.accrualNumber) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "billingPeriod",
              label: "Billing Period",
              width: "120",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "Description" },
          }),
          _c("el-table-column", { attrs: { prop: "remark", label: "Remark" } }),
          _vm.isInvoiceEditable()
            ? _c("el-table-column", {
                attrs: { prop: "actions", label: "Actions", width: "300" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _vm.isInvoiceEditable()
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "float-right",
                                  attrs: { type: "success", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showAddItem()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _vm._v(" Add Item "),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.isInvoiceEditable()
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "float-right",
                                  attrs: { type: "danger", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDeleteItem(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-delete" }),
                                  _vm._v(" Delete Item "),
                                ]
                              )
                            : _vm._e(),
                          _vm.isInvoiceEditable()
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "float-right mr-1",
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showEditItem(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-edit" }),
                                  _vm._v(" Edit Item "),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1078215381
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("hr"),
      _c(
        "h5",
        [
          _vm._v(" Attachments "),
          _vm.isAttachmentAmendable()
            ? _c(
                "el-button",
                {
                  staticClass: "float-right",
                  attrs: { type: "success", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.addDocument()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v(" Add Attachment "),
                ]
              )
            : _vm._e(),
          _c("span", { staticClass: "clearfix" }),
        ],
        1
      ),
      _vm._l(_vm.documents, function (document, k) {
        return _c(
          "b-row",
          { key: k, attrs: { lg: "12" } },
          [
            _c(
              "b-col",
              { attrs: { lg: "3" } },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: { label: _vm.$t("Document Type") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function (scope) {
                            return [
                              document.isRequired
                                ? _c("span", { staticClass: "required" }, [
                                    _vm._v("*"),
                                  ])
                                : _vm._e(),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("Document Type"))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c("el-input", {
                      attrs: { size: "small", readonly: document.isRequired },
                      on: {
                        change: function ($event) {
                          return _vm.updateDocument(document)
                        },
                      },
                      model: {
                        value: document.type,
                        callback: function ($$v) {
                          _vm.$set(document, "type", $$v)
                        },
                        expression: "document.type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "text-right", attrs: { lg: "9" } },
              [
                _c(
                  "b-form-group",
                  [
                    document.clientFilename
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mt-1",
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openDocument(document, k)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                document.clientFilename
                                  ? document.clientFilename
                                  : "No File"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isAttachmentAmendable() && !document.clientFilename
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mt-1",
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.uploadDocument(document, k)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                document.clientFilename
                                  ? document.clientFilename
                                  : "Select File"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isAttachmentAmendable() && document.clientFilename
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mt-1",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeDocument(document, k)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-delete" }),
                            _vm._v(" Remove"),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c("hr"),
      _c(
        "div",
        { staticClass: "actions mt-1 mb-1" },
        [
          _vm.getErpCan(_vm.getPermissionPrefix() + ".Email") &&
          (_vm.invoice.status === "CONFIRMED" || _vm.invoice.status === "SENT")
            ? _c(
                "el-button",
                {
                  staticClass: "float-right ml-1",
                  attrs: { type: "info", size: "small" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$refs.invoiceEmailView.emailInvoice(
                        _vm.invoice
                      )
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" Email "),
                ]
              )
            : _vm._e(),
          _vm.getErpCan(_vm.getPermissionPrefix() + ".Copy")
            ? _c(
                "el-button",
                {
                  staticClass: "float-right ml-1",
                  attrs: { type: "info", size: "small" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$refs.invoiceCopyView.copyInvoice(
                        _vm.invoice,
                        _vm.organization
                      )
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-copy-document" }),
                  _vm._v(" Copy "),
                ]
              )
            : _vm._e(),
          _vm.getErpCan(_vm.getPermissionPrefix() + ".Confirm") &&
          _vm.invoice.confirmTime === null
            ? _c(
                "el-button",
                {
                  staticClass: "float-right ml-1",
                  attrs: { type: "success", size: "small" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$refs.invoiceConfirmView.confirmInvoice(
                        _vm.invoice
                      )
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-check" }), _vm._v(" Confirm ")]
              )
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.getPermissionPrefix()) + " "),
          _vm.getErpCan(_vm.getPermissionPrefix() + ".Revise") &&
          _vm.invoice.status === "CONFIRMED"
            ? _c(
                "el-button",
                {
                  staticClass: "float-right ml-1",
                  attrs: { type: "warning", size: "small" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$refs.invoiceReviseView.reviseInvoice(
                        _vm.invoice
                      )
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-back" }), _vm._v(" Revise ")]
              )
            : _vm._e(),
          _vm.getErpCan(_vm.getPermissionPrefix() + ".FAConfirm") &&
          _vm.invoice.status === "CONFIRMED"
            ? _c(
                "el-button",
                {
                  staticClass: "float-right ml-1",
                  attrs: { type: "success", size: "small" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$refs.invoiceConfirmFaView.confirmFaInvoice(
                        _vm.invoice
                      )
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-check" }),
                  _vm._v(" F&A Confirm "),
                ]
              )
            : _vm._e(),
          _vm.getErpCan(_vm.getPermissionPrefix() + ".SunClose") &&
          _vm.invoice.status === "FA_CONFIRMED" &&
          _vm.invoice.sunCloseTime === null
            ? _c(
                "el-button",
                {
                  staticClass: "float-right ml-1",
                  attrs: { type: "success", size: "small" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$refs.invoiceSunCloseView.closeSunInvoice(
                        _vm.invoice
                      )
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-check" }),
                  _vm._v(" Sun Close "),
                ]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              staticClass: "float-right ml-1",
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.downloadInvoice(_vm.invoice)
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-paperclip" }),
              _vm._v(" Download PDF "),
            ]
          ),
          _c("div", { staticClass: "clearfix" }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "compact",
          attrs: {
            title:
              _vm.$t(_vm.showAction(_vm.popupAction)) +
              " - " +
              _vm.invoice.invoiceNumber,
            visible: _vm.isShowEditItem,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowEditItem = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              ref: "mainForm",
              attrs: { model: _vm.newItem },
            },
            [
              _c(
                "b-row",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "4" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Charge Code"),
                            prop: "chargeCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { size: "small", filterable: "" },
                              on: {
                                change: function ($event) {
                                  return _vm.onChargeCodeChange()
                                },
                              },
                              model: {
                                value: _vm.newItem.chargeCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newItem, "chargeCode", $$v)
                                },
                                expression: "newItem.chargeCode",
                              },
                            },
                            _vm._l(_vm.chargeCodes, function (item) {
                              return item.status === "ACTIVE"
                                ? _c(
                                    "el-option",
                                    {
                                      key: item.code,
                                      attrs: {
                                        label: item.value,
                                        value: item.code,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.category) +
                                          " > " +
                                          _vm._s(item.level1) +
                                          " > " +
                                          _vm._s(item.level2) +
                                          " > " +
                                          _vm._s(item.code) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "4" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Warehouse Code"),
                            prop: "warehouseCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                filterable: "",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.newItem.warehouseCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newItem, "warehouseCode", $$v)
                                },
                                expression: "newItem.warehouseCode",
                              },
                            },
                            _vm._l(_vm.warehouseCodes, function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item,
                                  attrs: { label: item, value: item },
                                },
                                [_vm._v(" " + _vm._s(item) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "4" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Billing Period"),
                            prop: "chargeCode",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { size: "small", type: "text" },
                            model: {
                              value: _vm.newItem.billingPeriod,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "billingPeriod", $$v)
                              },
                              expression: "newItem.billingPeriod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Unit Price"),
                            prop: "unitPrice",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "disableable",
                            attrs: {
                              size: "small",
                              type: "number",
                              step: "0.01",
                            },
                            nativeOn: {
                              change: function ($event) {
                                return _vm.updateItemTotal(_vm.newItem)
                              },
                            },
                            model: {
                              value: _vm.newItem.unitPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "unitPrice", $$v)
                              },
                              expression: "newItem.unitPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Item Currency"),
                            prop: "amount",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", size: "small" },
                              on: {
                                change: function ($event) {
                                  return _vm.updateItemTotal(_vm.newItem)
                                },
                              },
                              model: {
                                value: _vm.newItem.originalCurrency,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newItem, "originalCurrency", $$v)
                                },
                                expression: "newItem.originalCurrency",
                              },
                            },
                            _vm._l(_vm.currencies, function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item,
                                  attrs: { label: item, value: item },
                                },
                                [_vm._v(" " + _vm._s(item) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "1" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "times" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "48px",
                                "text-align": "center",
                                position: "relative",
                                top: "42px",
                              },
                            },
                            [_vm._v("×")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Qty"), prop: "qty" } },
                        [
                          _c("el-input", {
                            staticClass: "disableable",
                            attrs: {
                              size: "small",
                              type: "number",
                              step: "0.01",
                            },
                            nativeOn: {
                              change: function ($event) {
                                return _vm.updateItemTotal(_vm.newItem)
                              },
                            },
                            model: {
                              value: _vm.newItem.qty,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "qty", $$v)
                              },
                              expression: "newItem.qty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "1" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "equals" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "48px",
                                "text-align": "center",
                                position: "relative",
                                top: "42px",
                              },
                            },
                            [_vm._v("=")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Total " + " " + _vm.newItem.originalCurrency
                            ),
                            prop: "total",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "disableable",
                            attrs: { size: "small", readonly: "readonly" },
                            model: {
                              value: _vm.newItem.originalAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "originalAmount", $$v)
                              },
                              expression: "newItem.originalAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Total " + " " + _vm.newItem.currency
                            ),
                            prop: "total",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "disableable",
                            attrs: { size: "small", readonly: "readonly" },
                            model: {
                              value: _vm.newItem.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "amount", $$v)
                              },
                              expression: "newItem.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "6" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Description"),
                            prop: "description",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { size: "small", maxlength: "30" },
                            model: {
                              value: _vm.newItem.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "description", $$v)
                              },
                              expression: "newItem.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "6" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Remarks"), prop: "total" } },
                        [
                          _c("el-input", {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.newItem.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "remark", $$v)
                              },
                              expression: "newItem.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "6" } },
                    [
                      _vm.invoice.accruals.length === 0
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Item Level Accrual"),
                                prop: "accrualId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "value-key": "id", clearable: "" },
                                  model: {
                                    value: _vm.newItem.accrualId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newItem, "accrualId", $$v)
                                    },
                                    expression: "newItem.accrualId",
                                  },
                                },
                                _vm._l(_vm.companyAccruals, function (item) {
                                  return item.deleteTime === null
                                    ? _c(
                                        "el-option",
                                        {
                                          key: item.id,
                                          attrs: {
                                            label: item.accrualNumber,
                                            value: item.id,
                                            disabled:
                                              (item.chargeCodeEntity &&
                                                item.chargeCodeEntity.type ===
                                                  "AP") ||
                                              item.confirmTime !== null,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.accrualNumber) +
                                              " / Type: " +
                                              _vm._s(
                                                item.chargeCodeEntity &&
                                                  item.chargeCodeEntity.type
                                                  ? item.chargeCodeEntity.type
                                                  : "Unspecified"
                                              ) +
                                              " / Charge Code: " +
                                              _vm._s(item.chargeCode) +
                                              " / Warehouse Code: " +
                                              _vm._s(item.warehouseCode) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _c("div", [
                            _vm._v(
                              " Either Invoice Level or Item Level Accrual can be used. "
                            ),
                          ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.isLoading || !_vm.isItemAddable,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.saveItem()
                    },
                  },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "compact",
          attrs: {
            title: "Edit Footnote",
            visible: _vm.isShowEditFootnote,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowEditFootnote = $event
            },
          },
        },
        [
          _c("h5", [_vm._v(_vm._s(_vm.$t("Conversion Rates")))]),
          _c("el-input", {
            attrs: { type: "textarea", autosize: { minRows: 2, maxRows: 10 } },
            model: {
              value: _vm.invoice.exchangeRates,
              callback: function ($$v) {
                _vm.$set(_vm.invoice, "exchangeRates", $$v)
              },
              expression: "invoice.exchangeRates",
            },
          }),
          _c("hr"),
          _c("h5", [_vm._v(_vm._s(_vm.$t("Footnote 1")))]),
          _c("el-input", {
            attrs: { type: "textarea", autosize: { minRows: 2, maxRows: 10 } },
            model: {
              value: _vm.invoice.footnote1,
              callback: function ($$v) {
                _vm.$set(_vm.invoice, "footnote1", $$v)
              },
              expression: "invoice.footnote1",
            },
          }),
          _c("hr"),
          _c("h5", [_vm._v(_vm._s(_vm.$t("Footnote 2")))]),
          _c("el-input", {
            attrs: { type: "textarea", autosize: { minRows: 2, maxRows: 10 } },
            model: {
              value: _vm.invoice.footnote2,
              callback: function ($$v) {
                _vm.$set(_vm.invoice, "footnote2", $$v)
              },
              expression: "invoice.footnote2",
            },
          }),
          _c("hr"),
          _c("h5", [_vm._v(_vm._s(_vm.$t("Footnote 3")))]),
          _c("el-input", {
            attrs: { type: "textarea", autosize: { minRows: 2, maxRows: 10 } },
            model: {
              value: _vm.invoice.footnote3,
              callback: function ($$v) {
                _vm.$set(_vm.invoice, "footnote3", $$v)
              },
              expression: "invoice.footnote3",
            },
          }),
          _c("hr"),
          _c(
            "el-button",
            {
              staticClass: "float-right",
              attrs: { type: "success" },
              on: {
                click: function ($event) {
                  return _vm.saveFootnote()
                },
              },
            },
            [_vm._v("Save Footnote")]
          ),
          _c("div", { staticClass: "clearfix" }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "compact",
          attrs: {
            title: "Accruals",
            visible: _vm.isShowAccruals,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAccruals = $event
            },
          },
        },
        [
          _c("b-row", { attrs: { lg: "12" } }, [
            _c("table", { staticClass: "table mb-2" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Accrual Number")]),
                  _c("th", [_vm._v("Charge Code")]),
                  _c("th", [_vm._v("Category")]),
                  _c("th", [_vm._v("Level 1")]),
                  _c("th", [_vm._v("Level 2")]),
                  _c("th", [_vm._v("Warehouse Code")]),
                  _c("th", [_vm._v("Amount")]),
                  _c("th", [_vm._v("Actions")]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.invoice.accruals, function (accrual) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(accrual.accrualNumber))]),
                    _c("td", [_vm._v(_vm._s(accrual.chargeCode))]),
                    _c("td", [_vm._v(_vm._s(accrual.chargeCodeCategory))]),
                    _c("td", [_vm._v(_vm._s(accrual.chargeCodeLevel1))]),
                    _c("td", [_vm._v(_vm._s(accrual.chargeCodeLevel2))]),
                    _c("td", [_vm._v(_vm._s(accrual.warehouseCode))]),
                    _c("td", [
                      _vm._v(
                        _vm._s(accrual.totalAmount) +
                          " " +
                          _vm._s(accrual.currency)
                      ),
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.viewAccrual(accrual)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-view" }),
                            _vm._v(" View/Edit"),
                          ]
                        ),
                        _vm.isInvoiceEditable()
                          ? _c(
                              "el-link",
                              {
                                staticClass: "ml-1",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeAccrual(accrual)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-delete" }),
                                _vm._v(" Remove"),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
            _vm.isInvoiceEditable()
              ? _c("div", [
                  _c("hr"),
                  _vm.invoice.accruals.length === 0
                    ? _c("div", [
                        _vm.invoice.items
                          .map(function (item) {
                            return item.accrualId
                          })
                          .filter(function (i) {
                            return i
                          }).length > 0
                          ? _c("div", [
                              _vm._v(
                                " Either Invoice Level or Item Level Accrual can be used. "
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { "value-key": "id" },
                                    model: {
                                      value: _vm.newAccrual,
                                      callback: function ($$v) {
                                        _vm.newAccrual = $$v
                                      },
                                      expression: "newAccrual",
                                    },
                                  },
                                  _vm._l(_vm.companyAccruals, function (item) {
                                    return item.deleteTime === null
                                      ? _c(
                                          "el-option",
                                          {
                                            key: item.id,
                                            attrs: {
                                              label: item.accrualNumber,
                                              value: item,
                                              disabled:
                                                (item.chargeCodeEntity &&
                                                  item.chargeCodeEntity.type ===
                                                    "AP") ||
                                                item.confirmTime !== null,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.accrualNumber) +
                                                " / Type: " +
                                                _vm._s(
                                                  item.chargeCodeEntity &&
                                                    item.chargeCodeEntity.type
                                                    ? item.chargeCodeEntity.type
                                                    : "Unspecified"
                                                ) +
                                                " / Charge Code: " +
                                                _vm._s(item.chargeCode) +
                                                " / Warehouse Code: " +
                                                _vm._s(item.warehouseCode) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-1",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addNewAccrualSubmit()
                                      },
                                    },
                                  },
                                  [_vm._v("Link Invoice Level Accrual")]
                                ),
                              ],
                              1
                            ),
                      ])
                    : _c("div", [
                        _vm._v(" Only one Invoice Level Accrual is allowed. "),
                      ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Select Profile Rate",
            visible: _vm.isShowEditProfileRate,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowEditProfileRate = $event
            },
          },
        },
        [
          _c(
            "el-radio",
            {
              attrs: { label: "latest" },
              model: {
                value: _vm.profileRate.currencyProfileRateMode,
                callback: function ($$v) {
                  _vm.$set(_vm.profileRate, "currencyProfileRateMode", $$v)
                },
                expression: "profileRate.currencyProfileRateMode",
              },
            },
            [_vm._v("Latest Effective Rate")]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "billingPeriod" },
              model: {
                value: _vm.profileRate.currencyProfileRateMode,
                callback: function ($$v) {
                  _vm.$set(_vm.profileRate, "currencyProfileRateMode", $$v)
                },
                expression: "profileRate.currencyProfileRateMode",
              },
            },
            [_vm._v("Specific Billing Period")]
          ),
          _vm.profileRate.currencyProfileRateMode === "billingPeriod"
            ? _c(
                "div",
                { staticClass: "my-1" },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.profileRate.currencyProfileBillingPeriod,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.profileRate,
                            "currencyProfileBillingPeriod",
                            $$v
                          )
                        },
                        expression: "profileRate.currencyProfileBillingPeriod",
                      },
                    },
                    _vm._l(_vm.currencyProfileBillingPeriods, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("hr"),
          _c(
            "el-button",
            {
              staticClass: "float-right",
              attrs: { type: "success" },
              on: {
                click: function ($event) {
                  return _vm.saveProfileRate()
                },
              },
            },
            [_vm._v("Save Profile Rate")]
          ),
          _c("div", { staticClass: "clearfix" }),
        ],
        1
      ),
      _c("UploadModal", { ref: "uploadView" }),
      _c("InvoiceCopyModal", { ref: "invoiceCopyView" }),
      _c("InvoiceEmailModal", { ref: "invoiceEmailView" }),
      _c("InvoiceReviseModal", { ref: "invoiceReviseView" }),
      _c("InvoiceConfirmModal", { ref: "invoiceConfirmView" }),
      _c("InvoiceConfirmFaModal", { ref: "invoiceConfirmFaView" }),
      _c("InvoiceSunCloseModal", { ref: "invoiceSunCloseView" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }